import { ReportConfig } from "../definitions";

const affiliateWrittenReport: ReportConfig = {
  id: "affiliateWrittenReport",
  name: "Affiliate Written Report",
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "$YEAR-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "$YEAR-$MONTH-$DAY" },
    {
      name: "affiliate",
      label: "Affiliate",
      dataType: "select-dynamic",
      // defaultValue: 137,
      optionsDataSource: {
        sql: `
      SELECT 0 AS ID, 'Select an affiliate' AS [Name], 0 AS [SortOrder]
      UNION ALL
      SELECT ID, [Name], 1 as [SortOrder]
      FROM dbo.affiliate
      WHERE IsDeleted = 0
      ORDER BY [SortOrder], [Name]`,
        returnType: "options",
      },
    },
  ],
  layout: [
    {
      items: [
        {
          id: "item-1",
          title: "Policy count",
          widgetType: "figure",
          dataSource: {
            sql: `
if @affiliate = 0
BEGIN
  SELECT '-' as [Value]
  RETURN
END
ELSE
BEGIN

SELECT
  COUNT(DISTINCT CASE WHEN a.PolicyNumber IS NULL THEN CAST(a.ID AS VARCHAR) ELSE a.PolicyNumber END) as [Value]
FROM
  awu.Application a
  INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
  INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
  INNER JOIN dbo.Broker b on ab.BrokerID = b.ID
  INNER JOIN dbo.affiliate af on (ab.AffiliateID = af.ID OR b.AffiliateID = af.id)
  INNER JOIN awu.ApplicationStatus ast on a.ApplicationStatusID = ast.ID

WHERE a.EntryDate BETWEEN @startDate AND @endDate
    AND ast.[ScenarioTypeCode] = 'F'
    AND af.ID = @affiliate
    AND a.IsDeleted = 0
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)

END
            `,
            returnType: "scalar",
            returnExpression: "0.Value",
          },
          options: { color: "blue" },
        },
        {
          id: "item-2",
          title: "Total Premium",
          widgetType: "figure",
          dataSource: {
            sql: `
if @affiliate = 0
BEGIN
  SELECT '-' as [Value]
  RETURN
END
ELSE
BEGIN

SELECT
  SUM(ap.AnnualizedPremium * ab.CommissionPercent) as [Value]
FROM
  awu.Application a
  INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
  INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
  INNER JOIN dbo.Broker b on ab.BrokerID = b.ID
  INNER JOIN dbo.affiliate af on (ab.AffiliateID = af.ID OR b.AffiliateID = af.id)
  INNER JOIN awu.ApplicationStatus ast on a.ApplicationStatusID = ast.ID
WHERE a.EntryDate BETWEEN @startDate AND @endDate
    AND ast.[ScenarioTypeCode] = 'F'
    AND af.ID = @affiliate
    AND a.IsDeleted = 0
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
END
            `,
            returnType: "scalar",
            returnExpression: "0.Value",
            returnExpressionFormat: {
              type: "currency",
              name: null,
            },
          },
          options: { color: "blue" },
        },
      ],
    },
    {
      items: [
        {
          id: "item-1",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Company", type: "string" },
            { name: "Broker", type: "string" },
            { name: "Client", type: "string" },
            { name: "Policy Number", type: "string", summary: "distinct" },
            { name: "Carrier", type: "string" },
            { name: "Product", type: "string" },
            { name: "Status", type: "string" },
            { name: "Submitted", type: "date" },
            { name: "Mode", type: "string" },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `
if @affiliate is null or @affiliate = 0
BEGIN
  PRINT 'You must select a affiliate'
  RETURN
END
ELSE
BEGIN

SELECT
  c.Name as [Company],
  CONCAT(b.Firstname,' ', b.LastName)  Broker,
  CASE WHEN a.FirstName is null then
    e.Firstname + ' ' + e.LastName
  else
    a.FirstName + ' ' + a.LastName
  end AS [Client],
  a.PolicyNumber,
  cr.Type AS [Carrier],
  pl.Name AS [Product],
  ast.Description AS [Status],
  a.EntryDate AS [Submitted],
  CASE
    WHEN ap.Mode = 'A' THEN 'Annual'
    WHEN ap.mode = 'Q' THEN 'Quarterly'
    WHEN ap.mode = 'SA' THEN 'Semi-Annual'
    WHEN ap.mode = 'M' THEN 'Monthly'
    WHEN ap.mode = '1' THEN 'One Pay'
  END AS [Mode],
  ap.AnnualizedPremium * ab.CommissionPercent AS [Premium],
  ab.CommissionLevel,
  0 as Section
FROM awu.Application a
  INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
  INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
  INNER JOIN dbo.Broker b on ab.BrokerID = b.ID
  --INNER JOIN dbo.affiliate af on (ab.AffiliateID = af.ID)
  INNER JOIN dbo.affiliate af on (ab.AffiliateID = af.ID OR b.AffiliateID = af.id)

  INNER JOIN [dbo].CarrierType cr on a.CarrierID = cr.ID
  INNER JOIN awu.[Plan] pl on a.PlanID = pl.ID
  INNER JOIN awu.ApplicationStatus ast on a.ApplicationStatusID = ast.ID
  LEFT JOIN awu.applicationgrouppolicy gp ON a.ID=gp.ApplicationID
  OUTER APPLY (SELECT TOP 1 FirstName, LastName FROM awu.ExternalInsured WHERE a.GroupID=ExternalInsured.ApplicationID AND gp.ExternalNumber=ExternalInsured.ExternalNumber) e
  OUTER APPLY (SELECT TOP 1 * FROM dbo.Company WHERE id = b.CompanyID) as c

WHERE a.EntryDate between @startDate AND @endDate
  And ast.ScenarioTypeCode = 'F'
  and af.Id = @affiliate
  AND a.IsDeleted = 0
  AND (@_branch = 0 OR a.BranchTypeID = @_branch)

UNION

SELECT
  null,
  null,
  null,
  CAST(COUNT(DISTINCT CASE WHEN a.PolicyNumber IS NULL THEN CAST(a.ID AS VARCHAR) ELSE a.PolicyNumber END) AS VARCHAR),
  null,
  null,
  null,
  null,
  null,
  SUM(ap.AnnualizedPremium * ab.CommissionPercent) as [Value],
  null,
  1 as Section


FROM
  awu.Application a
  INNER JOIN awu.ApplicationBroker ab On a.ID = ab.ApplicationID
  INNER JOIN awu.ApplicationPremium ap on a.ID = ap.ApplicationID
  INNER JOIN dbo.Broker b on ab.BrokerID = b.ID
  INNER JOIN dbo.affiliate af on (ab.AffiliateID = af.ID OR b.AffiliateID = af.id)
  INNER JOIN awu.ApplicationStatus ast on a.ApplicationStatusID = ast.ID

WHERE a.EntryDate BETWEEN @startDate AND @endDate
    AND ast.[ScenarioTypeCode] = 'F'
    AND af.ID = @affiliate
    AND a.IsDeleted = 0
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)

ORDER BY Section, Submitted, PolicyNumber, CommissionLevel
END
            `,
            returnType: "table",
          },
          options: { summaryInData: true, zebraFieldIndex: [3, 2] },
        },
      ],
    },
  ],
};

export default affiliateWrittenReport;
